import { Building2, House } from "lucide-react";
import { useTranslation } from "react-i18next";
import { KioskStatePanel } from "../../../../../components/kiosk-state-panel";
import { KioskStep } from "../../../../../components/kiosk-step";

/**
 * Reception handoff screen: the kiosk cannot finish the patient's request and
 * says so plainly, with one way forward ("Zurück zum Start"). The panel is a
 * static status, not a tile that looks tappable (KC-34).
 *
 * @since 1.3.0
 * @example
 * ```tsx
 * <ReceptionHelpStep onComplete={() => undefined} />
 * ```
 */
export function ReceptionHelpStep({
  onComplete,
  testId = "frontdesk-reception-help",
}: {
  /** Ends the check-in flow and returns to the start screen. */
  readonly onComplete: () => void;
  /** `data-testid` of the status panel. */
  readonly testId?: string;
}) {
  const { t } = useTranslation();

  return (
    <KioskStep
      width="narrow"
      align="center"
      title={t("self-service.help-reception")}
      primaryAction={{
        label: t("self-service.check-in.staff-assist.start-over"),
        icon: House,
        onClick: onComplete,
        testId: "staff-assist-done",
      }}
    >
      <KioskStatePanel
        tone="info"
        icon={<Building2 />}
        title={t("self-service.help-reception")}
        body={t("self-service.help-reception-toast")}
        testId={testId}
      />
    </KioskStep>
  );
}
